import { Dialog, DialogContent } from "@/components/ui/dialog"

import type { Message } from "../../data/review-data"
import { FindingThread } from "../checklist/finding-thread"
import type { ReportFindingItem } from "../report-data"

/**
 * One finding's conversation, over the document view. A pop-up rather than in
 * place, because the callout cards are too narrow to hold a thread.
 *
 * Marking it read is the opener's job and only happens for a reader who may
 * post; a reader who may not (a viewer) gets the thread read-only.
 */
export function FindingMessagesDialog({
  finding,
  thread,
  onSend,
  onClose,
}: {
  /** The finding whose thread is open; null closes the dialog. */
  finding: ReportFindingItem | null
  thread: readonly Message[]
  onSend?: ((body: string) => void) | undefined
  onClose: () => void
}): JSX.Element {
  return (
    <Dialog
      open={finding !== null}
      onOpenChange={(open) => {
        if (!open) onClose()
      }}
    >
      {finding && (
        <DialogContent
          size="md"
          // A finding's title is a sentence, not a dialog heading's few words.
          title={
            <span className="text-heading">
              {finding.number}. {finding.title}
            </span>
          }
          description={
            onSend
              ? "Visible to everyone on this review."
              : "You can read this conversation. Replying is for the review team and the client."
          }
        >
          <div className="flex h-[min(420px,60dvh)] min-h-0 flex-col">
            <FindingThread messages={thread} onSend={onSend} focusComposer />
          </div>
        </DialogContent>
      )}
    </Dialog>
  )
}
